import React from 'react';
import { Outlet } from 'react-router-dom';
import TextPageLayout from 'web/components/TextPageLayout';

const HelpCenter = () => {
  return (
    <TextPageLayout>
      <Outlet />
    </TextPageLayout>
  );
};

export default HelpCenter;
